/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --background: var(--state-color-background);
  --color: var(--state-color);
  --gap: var(--nve-ref-space-xs);
  --height: var(--nve-ref-size-800);
  --width: var(--nve-ref-size-800);
  --font-size: calc(var(--width) / 2);
  --border-radius: calc(var(--height) * 0.2);
  --font-weight: var(--nve-ref-font-weight-bold);
  width: var(--width);
  height: var(--height);
  display: inline-block;
}

@supports not (background: color-mix(in oklab, #000 0%, #fff)) {
  :host([color]) [internal-host] {
    --background: var(--color);
    border: 1px solid transparent;
    background-image: linear-gradient(hsl(0 0% 0% / 0.8) 0 0) !important;
  }
}

[internal-host] {
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  gap: var(--gap);
  color: var(--color);
  width: var(--width);
  height: var(--height);
  border-radius: var(--border-radius);
  display: inline-flex;
  place-items: center;
  place-content: center;
  line-height: 0;
}

::slotted([nve-text]) {
  color: inherit !important;
}

::slotted(nve-icon) {
  --color: var(--state-color);
  --width: var(--font-size);
  --height: var(--font-size);
}

:host([size='sm']) {
  --width: var(--nve-ref-size-600);
  --height: var(--nve-ref-size-600);
}

:host([size='lg']) {
  --width: calc(var(--nve-ref-size-1000) * 1.55);
  --height: calc(var(--nve-ref-size-1000) * 1.55);
}

:host([color]) [internal-host] {
  background: var(--background);
}
